export class Hinge {
    constructor(
        public model: string,
        public light: string,
        public down: boolean,
    ) { }

    public get left(): boolean {
        return this.model.includes('L');
    }
}
